import { useRouter } from "next/navigation"
import styles from "@css/modules/PointChart.module.scss"
import { ArrowDown, ArrowLeft } from "@css/icons/SVG"
import cn from "classnames"
import Nouislider from "nouislider-react"
import { MobileFilters } from "./MobileFilters"
import { Select } from "antd"
import React from "react"

const formatter = (value) => {
    const val = Math.round(value)
    return val >= 1300 ? "Max" : val <= 50 ? "Any" : val
}
const tooltipFormatter = [{ to: formatter }]

export function Header({ resort, years, changeYear, selectedYear, points, searchParams }) {
    const router = useRouter()
    const pointsOrDays = searchParams.view !== "days"
    const onPointsChange = (tooltip, nup, [value]) => {
        const val = Math.round(value)
        const params = new URLSearchParams(searchParams)
        params.set("points", (val === 50 ? 0 : val).toString())
        router.push(`?${params.toString()}`)
    }

    function onRedirectBack(e) {
        e.preventDefault()
        if (searchParams.back) {
            router.push(searchParams.back)
        } else {
            router.push("/resorts/" + resort.slug)
        }
    }
    const setPointsOrDays = (isPoints) => {
        const params = new URLSearchParams(searchParams)
        params.set("view", isPoints ? "points" : "days")
        router.push(`?${params.toString()}`)
    }

    const filters = (
        <>
            <div className={styles.howMuchPoints}>
                How many points do you have?
                <div className={styles.filtersWrapper}>
                    <Nouislider
                        onChange={onPointsChange}
                        start={points}
                        connect={[true, false]}
                        behaviour={"tap-drag"}
                        tooltips={tooltipFormatter}
                        range={{
                            min: 50,
                            "50%": [300, 10],
                            max: 1600
                        }}
                        step={10}
                    />
                </div>
            </div>
            <div className={styles.pointsOrDaysWrapper}>
                <div onClick={() => setPointsOrDays(true)} className={cn(styles.pointsOrDays, pointsOrDays && styles.pointsOrDaysActive)}>
                    Weekly stay point distribution
                </div>
                <div onClick={() => setPointsOrDays(false)} className={cn(styles.pointsOrDays, !pointsOrDays && styles.pointsOrDaysActive)}>
                    No. of nights I can book with these points
                </div>
            </div>
        </>
    )

    return (
        <div className={styles.headWrapper}>
            <div className={styles.head}>
                <div className={styles.headSection1}>
                    <div>
                        <a href={"/resorts/" + resort.slug} className={styles.titleLink} onClick={onRedirectBack}>
                            <ArrowLeft className={styles.arrowLeft} />
                            {resort.short_name}
                        </a>
                    </div>
                    <div className={styles.selectYear}>
                        <div className={styles.desktopText}>Choose by year</div>
                        <div className={styles.yearBtnsWrapper}>
                            {years?.length > 3 ? (
                                <Select value={selectedYear} className={styles.yearSelect} suffixIcon={<ArrowDown width={16} />} onChange={changeYear}>
                                    {years.map((i) => (
                                        <Select.Option key={i} value={i}>
                                            {i}
                                        </Select.Option>
                                    ))}
                                </Select>
                            ) : (
                                years.map((i, k) => {
                                    return (
                                        <button className={cn(styles.yearBtn, selectedYear === i && styles.yearBtnActive)} key={i + k} onClick={() => changeYear(i)}>
                                            {i}
                                        </button>
                                    )
                                })
                            )}
                        </div>
                    </div>
                </div>
                <MobileFilters>{filters}</MobileFilters>
                <div className={styles.filtersDesktop}>{filters}</div>
            </div>
        </div>
    )
}
